import React from "react";
import { StepStatus, WelcomePageProps } from "../../../common/types";
import { CheckIcon } from "../../../common/Icons";
import CircleSpinner from "../../../common/loader/circleSpinner";

const WelcomePage: React.FC<WelcomePageProps> = ({
  userName,
  steps,
  onStepSelect,
  mainContentClassName,
  stepCompletionStatus,
  isLoader,
}) => {
  return (
    <main className={mainContentClassName || "w-full"}>
      <div className={`${isLoader === true ? "loaderGrey" : "loaderDisplay"}`}>
        <CircleSpinner />
      </div>
      <div className="p-2 bg-white sm:p-4 lg:p-6 rounded-lg shadow-lg h-full overflow-y-auto">
        {/* Greeting Section */}
        <div className="mb-4 sm:mb-6 lg:mb-8 text-center">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800">
            Hi {userName}! Your life just got easier
          </h1>
          <p className="text-base lg:text-2xl text-gray-600">
            Veros Credit has{" "}
            <span className="text-green-500 font-semibold">instant</span>{" "}
            application verification
          </p>
        </div>

        {/* Step Navigation Cards */}
        <h2 className="text-lg sm:text-xl font-semibold text-[#09517d] mb-2 sm:mb-3 lg:mb-4 text-center sm:text-left">
          Get Started by Selecting a Step:
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 sm:gap-3 md:gap-4">
          {steps.map((step) => {
            const IconComponent = step.icon;
            // Check both the original status and our fetched completion status
            const isCompleted =
              step.status === StepStatus.COMPLETED ||
              stepCompletionStatus[step.id] === true;

            let cardClasses =
              "p-2 sm:p-3 md:p-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 ease-in-out cursor-pointer flex flex-col items-center text-center min-h-[100px] sm:min-h-[110px] md:min-h-[120px] lg:min-h-[130px] justify-center ";
            let iconColor = "text-blue-600";
            let titleColor = "text-gray-700";

            if (isCompleted) {
              cardClasses += "bg-green-50 border border-green-200";
              iconColor = "text-green-600";
              titleColor = "text-green-700";
            } else {
              cardClasses +=
                "bg-white border border-gray-200 hover:border-blue-400";
            }

            return (
              <div
                key={step.id}
                className={cardClasses}
                onClick={() => onStepSelect(step.id)}
                onKeyPress={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    onStepSelect(step.id);
                  }
                }}
                tabIndex={0}
                role="button"
                aria-label={`Navigate to ${step.title}`}
              >
                <div className="flex items-center justify-center mb-2 sm:mb-2 md:mb-3">
                  {isCompleted ? (
                    <CheckIcon className="w-8 h-8 sm:w-10 sm:h-10 text-green-500" />
                  ) : (
                    <IconComponent
                      className={`w-8 h-8 sm:w-10 sm:h-10 ${iconColor}`}
                    />
                  )}
                </div>
                <h3 className={`text-lg font-medium ${titleColor}`}>
                  {step.title}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </main>
  );
};

export default WelcomePage;
